/**
 * HOA Scroll Reveal — hoa-scroll-reveal.js
 * IntersectionObserver-basiertes Reveal für Sections und Grids.
 * Kein externes Framework, native Web-API.
 *
 * Verwendung im Liquid:
 *   data-reveal        → ganze Section fadet ein
 *   data-reveal-grid   → Kinder werden gestaffelt eingeblendet
 */
(function () {
  'use strict';

  /* Kein Observer wenn User reduced-motion bevorzugt */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Elemente sofort sichtbar machen, die schon im Viewport sind */
  function revealElement(el) {
    el.classList.add('hoa-revealed');
  }

  /* Observer für [data-reveal] und [data-reveal-grid] */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealElement(entry.target);
          observer.unobserve(entry.target); /* einmal reicht */
        }
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -48px 0px'
    }
  );

  /* Alle Reveal-Elemente registrieren */
  function init() {
    document
      .querySelectorAll('[data-reveal], [data-reveal-grid]')
      .forEach(function (el) {
        observer.observe(el);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
